import * as React from 'react';
import { Button, ButtonPriority, ButtonSize } from '../../Button';
import { TextButton, TextButtonPriority } from '../../TextButton';
import { SECTION_NOTIFICATION_DATA_HOOKS } from '../dataHooks';
import { classes as parentClasses } from '../SectionNotification.st.css';
import {
  SectionNotificationType,
  SectionNotificationButtonProps,
  SectionNotificationButtonType,
} from '../types';
import { st, classes } from './SectionNotificationButton.st.css';
import { SectionNotificationConsumer } from '../SectionNotificationContext';

export class SectionNotificationButton extends React.Component<SectionNotificationButtonProps> {
  static displayName = 'SectionNotification.Button';
  static defaultProps = {
    type: SectionNotificationButtonType.default,
  };

  textButtonDefaultProps = {
    priority: TextButtonPriority.primary,
  };

  buttonDefaultProps = {
    priority: ButtonPriority.basic,
    size: ButtonSize.tiny,
  };

  render() {
    const { children, type, ...buttonProps } = this.props;
    const ButtonComponent: any =
      type === SectionNotificationButtonType.text ? TextButton : Button;

    const defaultButtonProps =
      type === SectionNotificationButtonType.text
        ? this.textButtonDefaultProps
        : this.buttonDefaultProps;

    return (
      <SectionNotificationConsumer>
        {({ type: notificationType }) => (
          <div
            className={st(
              classes.root,
              {
                type,
                wired: notificationType === SectionNotificationType.wired,
              },
              parentClasses.button,
            )}
            data-hook={SECTION_NOTIFICATION_DATA_HOOKS.button}
          >
            <ButtonComponent
              className={st(classes.button, {
                priority:
                  (buttonProps as any).priority || defaultButtonProps.priority,
              })}
              {...defaultButtonProps}
              {...buttonProps}
            >
              {children}
            </ButtonComponent>
          </div>
        )}
      </SectionNotificationConsumer>
    );
  }
}
